module.exports = __webpack_public_path__ + "media/components/assets/icons/teacher_together-e5f3dca60b7ec33e98af9aff29bdfa1c.svg";